import { MAP_TYPE } from 'maps/types'

export const isGarmentStoresType = (type?: MAP_TYPE) =>
	type === MAP_TYPE.GARMENT_STORES
export const isStoresType = (type?: MAP_TYPE) => type === MAP_TYPE.STORES
export const isDroppointType = (type?: MAP_TYPE) => type === MAP_TYPE.DROPPOINTS
